import React from "react";

export function MultiSelectCodesRenderer(props: any) {
	const { value, cellProperties, data } = props;
	const txt: any[] = [];

	const formatValue = () => {
		if (value) {
			//build data
			const sp = value.split(";");
			if (Array.isArray(sp) && data && Array.isArray(data)) {
				cellProperties.data = JSON.stringify(
					sp.map((label) => {
						const it = data.find((x) => x.code === label.trim());
						if (!it) return value;
						txt.push(it.code || it.value);
						return { value: it.id, label: it.label, code: it.code };
					})
				);
			}
			return txt.length > 0 ? txt.join("; ") : value;
		} else {
			return value;
		}
	};
	// The avaiable renderer-related props are:
	// - row (row index)
	// - col (column index)
	// - prop (column property name)
	// - TD (the HTML cell element)
	// - cellProperties (the cellProperties object for the edited cell)
	// console.log(txt);

	return formatValue();
	// <>
	// 	<i style={{ color: "#a9a9a9" }}>
	// 		Row: {props.row}, column: {props.col},
	// 	</i>{" "}
	// 	value: {props.value}
	// </>
}
